(function (document, window, $) {
    'use strict';
    var ajaxParams = {};

    var order = [[0, 'asc']];

    if ($('[data-order]').length) {
        var $field = $('[data-order]');
        order = [[$field.data('field-key'), $field.data('order')]];
    }else if ($('[name="bulk_actions"]').length) {
        order = [[1, 'asc']];
    }

    var columnDefs = [];

    columnDefs.push({targets: 'nofilter', searchable: false});
    columnDefs.push({targets: 'noorder', orderable: false});

    $('thead th').each(function (key) {
        if ($(this).data('class-row')) {
            columnDefs.push({
                targets: key,
                className: $(this).data('class-row'),
                width: 'auto' // Resize columns to fit the content AND the column header
            });
        }
    });

    window.AppDatatable = {
        /**
         * Default options
         */
        defaults: {
            cache: false,
            processing: true,
            serverSide: true,
            stateSave: true,
            searching: true,
            responsive: false,
            autoWidth: false,
            ajax: {
                data: function (data) { // add request parameters before submit
                    var tableLocal = window.AppDatatable.$table.DataTable();

                    window.AppDatatable.$table.find('.form-filter').each(function () {
                        var colIdx = $(this).parents("th").attr('data-field-key');

                        var value = tableLocal
                            .column(colIdx)
                            .search();

                        var key = $(this).attr('name');

                        try {
                            var localValue = JSON.parse(value);

                            if(typeof localValue == "object"){
                                value = localValue[key];
                            }
                        } catch (e) {

                        }

                        data[key] = value;
                    });
                    $('#app-datatable colgroup').remove();
                    // Récupération des filtres saisies dans "moreFilters"
                    $('#datatable-more-filters .form-filter').each(function () {
                        var value = $(this).val();

                        var key = $(this).attr('name');

                        try {
                            var localValue = JSON.parse(value);

                            if(typeof localValue == "object"){
                                value = localValue[key];
                            }
                        } catch (e) {

                        }

                        data[key] = value;
                    });
                }
            },
            columnDefs: columnDefs,
            order: order,
            lengthMenu: [25, 50, 75, 100, 150, 200, 250, 500],
            language: {
                processing: '',
                search: '',
                sSearchPlaceholder: 'Recherche...',
                emptyTable: 'Pas de donnée disponible dans le tableau',
                paginate: {
                    first: '<<',
                    last: '>>',
                    next: '>',
                    previous: '<'
                },
                info: 'Affichage de l\'élément _START_ à _END_ sur _TOTAL_ élément(s) trouvé(s)',
                infoFiltered: '',
                infoEmpty: '',
                thousands: '',
                lengthMenu: '_MENU_',
                loadingRecords: '',
                zeroRecords: 'Aucun enregistrement correspondant trouvé'
            },
            drawCallback: function (settings) {
                if (settings._iRecordsDisplay <= 25) {
                    $('.dt-length').hide();
                    $('.dt-paging').hide();
                    $('#app-datatable_wrapper > :first-child').hide();
                    $('#app-datatable_wrapper').children().eq(1).removeClass('mt-2');
                } else {
                    $('.dt-length').show();
                    $('.dt-paging').show();
                }
                window.AppDatatable.onDatatableDraw();
            },
            fnRowCallback: function (nRow, aData, iDisplayIndex) {
                nRow.className = 'footable-even';

                // Ajoute un fond de couleur si dispo
                if(aData.backgroudColor) {
                    nRow.style.setProperty("background-color", aData.backgroudColor, "important");
                }

                // Ajoute une couleur de texte si dispo
                if(aData.color) {
                    nRow.style.setProperty("color", aData.color, "important");
                }

                // Ajoute une graisse de police si dispo
                if(aData.weight) {
                    nRow.style.fontWeight = aData.weight;
                }

                return nRow;
            },
            /**
             * the jQuery selector of the datatable element
             */
            selector: '#app-datatable',
            rowReorder: {
                selector: '.repositionnable',
                update:false
            }
        },
        /**
         * options contains:
         *  - selector the jQuery selector of the datatable elemen (default: #backend-datatable)
         * @param Object options
         * @returns Datatable Object
         */
        handleDataTable: function (options) {
            options = $.extend(AppDatatable.defaults, options);

            if ($.fn.DataTable) {
                var $table = $(options.selector);

                window.AppDatatable.$table = $table;

                var table = window.AppDatatable.table = $table.DataTable(options);

                table.on('responsive-display', function(e, datatable, columns){
                    window.AppDatatable.onDatatableDraw();
                });

                var $loader = $('.loader-wrapper');

                table.on('processing.dt', function (e, settings, processing) {
                    if (processing) {
                        $loader.addClass('active');
                    } else {
                        $loader.removeClass('active');
                    }
                });

                table.on( 'row-reorder', function ( e, diff, edit ) {
                    var result = [];

                    for ( var i=0, ien=diff.length ; i<ien ; i++ ) {
                        var rowData = table.row( diff[i].node ).data();

                        result.push({
                            id:rowData.DT_RowId,
                            newPosition:diff[i].newPosition
                        });
                    }

                    $.ajax({
                        url: $table.data('pos-url'),
                        method:'PUT',
                        dataType: 'json',
                        data: {data:result},
                        success: function (data) {
                            table.ajax.reload();
                            toastr.success(data.message);
                        }
                    });
                });

                window.AppDatatable.initTableFilters($table, table);
                window.AppDatatable.initMoreFilters($('#datatable-more-filters'), table);
                window.AppDatatable.generateDivGlobalSelectionDiv();
                return table;
            }
        },
        setAjaxParam: function (name, value) {
            ajaxParams[name] = value;
        },
        /**
         *
         * @param table
         * @returns
         */
        submitFilter: function (table) {
            // get all typeable inputs
            $('.form-filter').each(function () {
                var $filter = $(this);
                var $parent = $filter.parents("th");

                var colIdx = $parent.attr('data-field-key');
                var localValue = $filter.val();

                if($('.form-filter', $parent).length > 1){
                    localValue = {};

                    $('.form-filter', $parent).each(function(key,item){
                        localValue[$(item).attr('name')] = $(item).val();
                    });

                    localValue = JSON.stringify(localValue);
                }

                table
                    .column(colIdx)
                    .search(localValue);
            });

            table.ajax.reload();
        },

        initTableFilters: function ($table, table) {
            $table.find('.form-filter').each(function () {
                var colIdx = $(this).parents("th").attr('data-field-key');
                var value = table
                    .column(colIdx)
                    .search();

                try {
                    var localValue = JSON.parse(value);

                    if(typeof localValue == "object"){
                        value = localValue[$(this).attr('name')];
                    }
                } catch (e) {

                }

                $(this).val(value);
            });

            window.AppDatatable.initFilters($table, table);
        },

        initMoreFilters: function($moreFilters, table){
            window.AppDatatable.initFilters($moreFilters, table);
        },

        /**
         * Initialize Filters
         * @param $element $table
         * @returns
         */
        initFilters: function ($container, table) {
            window.AppDatatable.initSelectFilter($container);

            $container.find('input').on('keyup', window.AppDatatable.debounce(function () {
                if ($(this).hasClass('nofilter'))
                {
                    return false;
                }

                window.AppDatatable.submitFilter(table);
            }, 100));

            $container.find('select').on('change', function (event) {
                event.preventDefault();
                window.AppDatatable.submitFilter(table);
            });

            $container.find('.date-picker input').on('change', function (event) {
                event.preventDefault();
                window.AppDatatable.submitFilter(table);
            });

            $container.find('input[type="checkbox"]#select-all').on('change', function (event) {
                event.preventDefault();
                $('input[type="checkbox"][name="select-row"]').prop('checked', $(this).is(':checked'));
            });


            $('#btn-reset, .btn-reset-datatable-filters').click(function () {
                window.AppDatatable.resetFilters(table);
            });
        },

        resetFilters: function(table){
            $('.form-filter').each(function () {
                var $this = $(this);
                this.value = '';

                // Pour les select non multiple, on sélectionne la premiere option
                if(!this.hasAttribute('multiple') && this.querySelector("option:first-child")) {
                    this.value = this.querySelector("option:first-child").value;
                }

                this.dispatchEvent(new Event("change"));
            });

            window.AppDatatable.submitFilter(table);
        },

        /**
         * Initialize select2
         * @param $Element $table
         * @returns
         */
        initSelectFilter: function ($table) {
            $table.find('select').select2();
        },
        /**
         * Called when the datatable is redrawn
         * @returns
         */
        onDatatableDraw: function () {
            // À chaque redraw, on dispose les anciennes instances Bootstrap 5 sur les
            // boutons toggle et on en crée de nouvelles. Sans ça, _isHovered reste à true
            // après la fermeture de la swal (mouseover synthétique), et Bootstrap 5 bloque
            // le prochain affichage via son guard « if (_isHovered) return ».
            if (typeof window.bootstrap !== 'undefined' && window.bootstrap.Tooltip) {
                document.querySelectorAll('a.toggle-active[data-bs-toggle="tooltip"]').forEach(function (el) {
                    var old = window.bootstrap.Tooltip.getInstance(el);
                    if (old) { old.dispose(); }
                    new window.bootstrap.Tooltip(el);
                });
            }
            this.handleBootstrapSwitch();
            this.handleToggleActive();
            this.handleDeleteModal();
        },
        /**
         *  initialize switch on datatable using data-witch-urk
         * @returns
         */
        handleBootstrapSwitch: function () {
            if (!$().bootstrapSwitch) {
                return;
            }
            $('.make-switch').bootstrapSwitch().on('switchChange.bootstrapSwitch', function (event, state) {
                var $this = $(this);
                window.AppDatatable.executeSwitchChange($this.attr('data-switch-url'), state);
            });
        },
        handleToggleActive: function () {
            $('a.toggle-active').on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                var $this = $(this);
                var el = $this[0];

                // 1. Hide the tooltip currently shown on this button.
                //    When using Bootstrap 5 delegated tooltips (selector on document.body),
                //    a sub-instance is created and stored on the trigger element itself
                //    the moment the user hovers. getInstance(el) retrieves that sub-instance
                //    and hide() properly closes the tooltip and resets internal state.
                if (typeof window.bootstrap !== 'undefined' && window.bootstrap.Tooltip) {
                    var instance = window.bootstrap.Tooltip.getInstance(el);
                    if (instance) {
                        instance.hide();
                    }
                }

                var state = $this.data('active');

                if (!state) {
                    // Quand swal ferme son overlay, le navigateur génère un mouseover
                    // synthétique sur l'élément en dessous, ce qui pousse Bootstrap 5
                    // à ré-afficher le tooltip. On intercepte l'événement « show.bs.tooltip »
                    // une seule fois via preventDefault() — Bootstrap 5 abandonne l'affichage
                    // si defaultPrevented est vrai. Le listener { once: true } se retire
                    // automatiquement après ce premier déclenchement, donc les survols
                    // ultérieurs (y compris sur le nouvel élément créé par ajax.reload())
                    // fonctionnent normalement sans aucun état résiduel.
                    el.addEventListener('show.bs.tooltip', function (e) {
                        e.preventDefault();
                    }, { once: true });

                    swal({
                        animation: false,
                        customClass: 'animated fadeIn',
                        title: 'Êtes-vous sûr ?',
                        allowOutsideClick: true,
                        type: 'warning',
                        showCancelButton: true,
                        closeOnConfirm: false,
                        closeOnCancel: true,
                        confirmButtonColor: '#D2282D',
                        cancelButtonText: 'Annuler',
                        confirmButtonText: 'Oui !',
                        showLoaderOnConfirm: true,
                        preConfirm: function () {
                            return new Promise(function (resolve) {
                                window.AppDatatable.executeSwitchChange($this.attr('href'), state, undefined, undefined, resolve);
                            });
                        }
                    }).then(function (result) {
                        swal.close();
                    });
                } else {
                    window.AppDatatable.executeSwitchChange($this.attr('href'), state);
                }
            });
        },
        /**
         * Execute the swith change ajax query
         * @param string url
         * @returns void
         */
        executeSwitchChange: function (url, state, callbackSuccess, callbackError, callbackComplete) {
            $.ajax({
                method: 'PUT',
                url: url,
                data: {
                    state: state ? 1 : 0
                },
                statusCode: {
                    404: function (xhr) {
                        CoreNotification.error('Cette ligne n\'existe plus.');
                    },
                    500: function (xhr) {
                        CoreNotification.error('Une erreur est survenue.');
                    }
                },
                success: function (data) {
                    if(data.status == 'change-not-allowed'){
                        if (data.hasOwnProperty('errorMsg')) {
                            CoreNotification.error(data.errorMsg);
                        }else{
                            CoreNotification.error('Complétez toutes les étapes pour pouvoir changer le statut');
                        }
                    }else{
                        CoreNotification.success('Changement d\'état effectué avec succès');

                        if (callbackSuccess !== undefined) {
                            callbackSuccess();
                        }
                    }
                },
                error: function (data) {
                    var response = JSON.parse(data.responseText);
                    if (typeof(response.messages) !== 'undefined') {
                        var message = response.main_message + '<br/>';
                        $(response.messages).each(function (index, msg) {
                            message += (index + 1) + '. ' + msg;
                        });
                        CoreNotification.error(message);
                    }

                    if (callbackError !== undefined) {
                        callbackError();
                    }
                },
                complete: function (data) {
                    window.AppDatatable.table.ajax.reload();
                    if (callbackComplete !== undefined) {
                        callbackComplete();
                    }
                }
            });
        },
        /**
         * initialize confirmation on datatable
         * @returns
         */
        handleDeleteModal: function () {
            var deleteUrl = null;
            $('[data-delete-url]').click(function (e) {
                e.preventDefault();
                deleteUrl = $(this).attr('data-delete-url');
                swal({
                    animation: false,
                    customClass: 'animated fadeIn',
                    title: 'Êtes-vous sûr ?',
                    allowOutsideClick: true,
                    html: $(this).data('text'),
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: "#D2282D",
                    cancelButtonText: 'Annuler',
                    confirmButtonText: "Oui !",
                    showLoaderOnConfirm: true,
                    preConfirm: function () {
                        return new Promise(function (resolve) {
                            AppDatatable.executeDeleteRow(deleteUrl, resolve, function() {
                                swal('', 'Erreur lors de la suppression', 'error');
                            }, undefined);
                        });
                    }
                }).then(function (result) {
                    swal.close();
                });
            });
        },
        /**
         * Execute the delete query ajax
         * @param string url
         * @returns
         */
        executeDeleteRow: function (url, callbackSuccess, callbackError, callbackComplete) {
            $.ajax({
                method: 'DELETE',
                url: url,
                statusCode: {
                    404: function (xhr) {
                        CoreNotification.error('Cette ligne a déjà été supprimée.');
                    },
                    500: function (xhr) {
                        // CoreNotification.error('Une erreur est survenue.');
                    }
                },
                success: function (data) {
                    CoreNotification.success('Suppression effectuée avec succès.');

                    if (callbackSuccess !== undefined) {
                        callbackSuccess();
                    }
                },
                error: function (data) {
                    var response;

                    try {
                        response = JSON.parse(data.responseText);
                    } catch(e) {
                        console.log('Une erreur est survenue à la tentative de parsing de la réponse');
                    }

                    if (typeof(response) !== 'undefined' && typeof(response.messages) !== 'undefined') {
                        var message = response.main_message + '<br/>';

                        $(response.messages).each(function (index, msg) {
                            message += (index + 1) + '. ' + msg;
                        });

                        CoreNotification.error(message);
                    }

                    if (callbackError !== undefined) {
                        callbackError();
                    }
                },
                complete: function (data) {
                    window.AppDatatable.table.ajax.reload();

                    if (callbackComplete !== undefined) {
                        callbackComplete();
                    }
                }
            });
        },

        generateDivGlobalSelectionDiv: function (){
            window.AppDatatable.SelectAll = false;
            $('#globalSelection').remove();
            $('input#select-all').on('click', function () {
                if(($(this).prop('checked')))
                {
                    var row_on_page = (AppDatatable.table.context[0]._iDisplayLength < AppDatatable.table.context[0]._iRecordsDisplay ) ? AppDatatable.table.context[0]._iDisplayLength :  AppDatatable.table.context[0]._iRecordsDisplay;
                    var row_total = AppDatatable.table.context[0]._iRecordsDisplay;
                    if(row_total > row_on_page){
                        var linkTotal = "<a href='#'>Sélectionner les "+row_total+" éléments.<a>";
                        var div_clear = "<div style='clear: both'></div>";
                        var div = "<div id='globalSelection' class='alert alert-info' role='alert'>Les "+row_on_page+" éléments de cette page sont sélectionnés. "+linkTotal+"</div>"
                        $('#dt-length-0').after(div_clear + div);
                        $('div#globalSelection>a').on('click', function () {
                            $('div#globalSelection').empty().html("Les "+row_total+" éléments sont maintenant sélectionnés.");
                            window.AppDatatable.SelectAll = true;
                            window.AppDatatable.SelectAll_expection = [];
                            $("#app-datatable tbody input:checked").on('click', function () {
                                if(($('div#globalSelection')).length){
                                    $('#globalSelection').remove();
                                }
                                if(window.AppDatatable.SelectAll_expection.indexOf(this.value) == -1 ){
                                    window.AppDatatable.SelectAll_expection.push(this.value);
                                }else{
                                    window.AppDatatable.SelectAll_expection.splice(window.AppDatatable.SelectAll_expection.indexOf(this.value), 1);
                                }
                            });
                        });
                    }
                }
                else
                {
                    $('#globalSelection').remove();
                    window.AppDatatable.SelectAll = false;
                }
            });
        },
        debounce: function(callback, delay){
            var timer;
            return function(){
                var args = arguments;
                var context = this;
                clearTimeout(timer);
                timer = setTimeout(function(){
                    callback.apply(context, args);
                }, delay)
            }
        }
    };
})(document, window, jQuery);
